unit Place;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, WEBLib.Buttons, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCBitmapContainer;

type
  TfrmPlace = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebPanel4: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    dgPlace: TTMSFNCDataGrid;
    wcPlaces: TXDataWebClient;
    wdsPlaces: TXDataWebDataSet;
    dsPlaces: TDataSource;
    dgdbaPlace: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCBitmapContainer1: TTMSFNCBitmapContainer;
    WebButton2: TButton;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    edtPlacePC: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    wdsPlacesLoadingNo: TIntegerField;
    wdsPlacesName: TStringField;
    wdsPlacesCityNo: TIntegerField;
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure dgPlaceCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }

    iPlacePC , iPlaceMaxPC : Integer;

    procedure LoadPlaces;

  public
    { Public declarations }
    sPlace : String;
    iPlaceNo : Integer;

  protected procedure LoadDFMValues; override; end;

var
  frmPlace: TfrmPlace;

implementation

{$R *.dfm}
uses
  share.classes, share.common, stfmssystem.connection, Places;

{ TfrmPlace }

procedure TfrmPlace.dgPlaceCellClick(Sender: TObject; AColumn, ARow: Integer);
begin
  sPlace := dgdbaPlace.FieldAtColumn[1].AsString;
  iPlaceNo := dgdbaPlace.FieldAtColumn[0].AsInteger;
end;

procedure TfrmPlace.LoadPlaces;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadPlaces;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);

    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadPlaces;
        end
      else
        begin
          wdsPlaces.Close;
          wdsPlaces.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsPlaces.Open;
        end;
    end;

  procedure OnSuccessPC(Response : TXDataClientResponse);
    var
    LoadingInfoParams : TLoadingInfoParams;
    sLoadingJson : String;
    begin
      iPlaceMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtPlacePC.Text := IntToStr(iPlacePC) + ' of ' + IntToStr(iPlaceMaxPC);

      LoadingInfoParams := TLoadingInfoParams.Create;
      LoadingInfoParams.PageCount := iPlacePC;

      sLoadingJson := ConvertObjToJson(LoadingInfoParams).ToString;


      wcPlaces.RawInvoke('IstfmsloadsService.Get_Places_View',[sLoadingJson],@OnSuccess,@OnError);
    end;

begin
  wcPlaces.RawInvoke('IstfmsloadsService.Get_Places_MaxPC',[],@OnSuccessPC,@OnError);
end;

procedure TfrmPlace.WebButton1Click(Sender: TObject);
begin
  sPlace := '';
  iPlaceNo := 0;
  Close;
end;

procedure TfrmPlace.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmPlace.WebFormShow(Sender: TObject);
begin
  iPlacePC := 1;

  LoadPlaces;
end;

procedure TfrmPlace.WebSpeedButton5Click(Sender: TObject);
var
  sPlace : String;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Place Successfully Saved');
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;
begin

  sPlace := InputBox('Place','Enter a new Place','');

  wdsPlaces.Insert;
  wdsPlaces.FieldByName('Name').AsString := sPlace;

  wcPlaces.RawInvoke('IstfmsloadsService.Put_Place_Insert',[GetJsonFromDataSet(wdsPlaces)],@OnSuccess,@OnError);
end;

procedure TfrmPlace.WebSpeedButton6Click(Sender: TObject);
begin
  iPlacePC := 1;
  LoadPlaces;
end;

procedure TfrmPlace.WebSpeedButton7Click(Sender: TObject);
begin
  if iPlacePC > 1 then
    Begin
      Dec(iPlacePC);
      LoadPlaces;
    End;
end;

procedure TfrmPlace.WebSpeedButton8Click(Sender: TObject);
begin
  if iPlacePC < iPlaceMaxPC then
    Begin
      Inc(iPlacePC);
      LoadPlaces;
    End;
end;

procedure TfrmPlace.WebSpeedButton9Click(Sender: TObject);
begin
  iPlacePC := iPlaceMaxPC;
  LoadPlaces;
end;

procedure TfrmPlace.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  TMSFNCBitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  edtPlacePC := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  dgPlace := TTMSFNCDataGrid.Create(Self);
  dgdbaPlace := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcPlaces := TXDataWebClient.Create(Self);
  wdsPlaces := TXDataWebDataSet.Create(Self);
  wdsPlacesLoadingNo := TIntegerField.Create(Self);
  wdsPlacesName := TStringField.Create(Self);
  wdsPlacesCityNo := TIntegerField.Create(Self);
  dsPlaces := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  TMSFNCBitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  edtPlacePC.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  dgPlace.BeforeLoadDFMValues;
  dgdbaPlace.BeforeLoadDFMValues;
  wcPlaces.BeforeLoadDFMValues;
  wdsPlaces.BeforeLoadDFMValues;
  wdsPlacesLoadingNo.BeforeLoadDFMValues;
  wdsPlacesName.BeforeLoadDFMValues;
  wdsPlacesCityNo.BeforeLoadDFMValues;
  dsPlaces.BeforeLoadDFMValues;
  try
    Name := 'frmPlace';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Loading/Off Loading Company';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    TMSFNCBitmapContainer1.SetParentComponent(WebPanel2);
    TMSFNCBitmapContainer1.Name := 'TMSFNCBitmapContainer1';
    TMSFNCBitmapContainer1.Left := 520;
    TMSFNCBitmapContainer1.Top := 24;
    TMSFNCBitmapContainer1.Width := 26;
    TMSFNCBitmapContainer1.Height := 26;
    TMSFNCBitmapContainer1.Visible := True;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 128;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Close';
    WebButton1.Color := clSkyBlue;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 16;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Select';
    WebButton2.Color := clGreenyellow;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 270;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '<';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 2;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 240;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 3;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    edtPlacePC.SetParentComponent(WebPanel3);
    edtPlacePC.Name := 'edtPlacePC';
    edtPlacePC.Left := 300;
    edtPlacePC.Top := 16;
    edtPlacePC.Width := 60;
    edtPlacePC.Height := 22;
    edtPlacePC.Alignment := taCenter;
    edtPlacePC.ChildOrder := 7;
    edtPlacePC.HeightPercent := 100.000000000000000000;
    edtPlacePC.Text := '1 of 1';
    edtPlacePC.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel3);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 366;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 5;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 396;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '>>';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 6;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 640;
    WebPanel4.Height := 53;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 2;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel4);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 16;
    WebSpeedButton1.Top := 6;
    WebSpeedButton1.Width := 40;
    WebSpeedButton1.Height := 40;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(WebPanel4);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 62;
    WebSpeedButton2.Top := 6;
    WebSpeedButton2.Width := 40;
    WebSpeedButton2.Height := 40;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel4);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 108;
    WebSpeedButton3.Top := 6;
    WebSpeedButton3.Width := 40;
    WebSpeedButton3.Height := 40;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel4);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 154;
    WebSpeedButton4.Top := 6;
    WebSpeedButton4.Width := 40;
    WebSpeedButton4.Height := 40;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(WebPanel4);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 200;
    WebSpeedButton5.Top := 6;
    WebSpeedButton5.Width := 40;
    WebSpeedButton5.Height := 40;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    dgPlace.SetParentComponent(WebPanel1);
    dgPlace.Name := 'dgPlace';
    dgPlace.Left := 0;
    dgPlace.Top := 113;
    dgPlace.Width := 640;
    dgPlace.Height := 307;
    dgPlace.Align := alClient;
    dgPlace.ParentDoubleBuffered := False;
    dgPlace.DoubleBuffered := True;
    dgPlace.TabOrder := 3;
    dgPlace.ShowAcceleratorChar := False;
    dgPlace.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgPlace.Header.VisualGrouping.Layout.Font.Height := -12;
    dgPlace.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgPlace.Header.VisualGrouping.Layout.Font.Style := [];
    dgPlace.Adapter := dgdbaPlace;
    dgPlace.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgPlace.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgPlace.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgPlace.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgPlace.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.BandLayout.Font.Height := -12;
    dgPlace.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.BandLayout.Font.Style := [];
    dgPlace.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.FixedLayout.Font.Height := -12;
    dgPlace.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.FixedLayout.Font.Style := [];
    dgPlace.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgPlace.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgPlace.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.FocusedLayout.Font.Height := -12;
    dgPlace.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.FocusedLayout.Font.Style := [];
    dgPlace.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.GroupLayout.Font.Height := -12;
    dgPlace.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.GroupLayout.Font.Style := [];
    dgPlace.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.NormalLayout.Font.Height := -12;
    dgPlace.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.NormalLayout.Font.Style := [];
    dgPlace.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.SelectedLayout.Font.Height := -12;
    dgPlace.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.SelectedLayout.Font.Style := [];
    dgPlace.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgPlace.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgPlace.CellAppearance.SummaryLayout.Font.Height := -12;
    dgPlace.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgPlace.CellAppearance.SummaryLayout.Font.Style := [];
    dgPlace.ColumnCount := 3;
    dgPlace.Columns.Clear;
    with dgPlace.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LoadingNo';
    end;
    with dgPlace.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    with dgPlace.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CityNo';
    end;
    dgPlace.Designer := False;
    dgPlace.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgPlace.FilterAppearance.Font.Color := clWindowText;
    dgPlace.FilterAppearance.Font.Height := -12;
    dgPlace.FilterAppearance.Font.Name := 'Segoe UI';
    dgPlace.FilterAppearance.Font.Style := [];
    dgPlace.Icons.ExpandIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.ExpandIcon.svg');
    dgPlace.Icons.CollapseIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.CollapseIcon.svg');
    dgPlace.Icons.FilterIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.FilterIcon.svg');
    dgPlace.Icons.FilterActiveIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.FilterActiveIcon.svg');
    dgPlace.Icons.FilterClearIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.FilterClearIcon.svg');
    dgPlace.Icons.FilterTypeIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.FilterTypeIcon.svg');
    dgPlace.Icons.SortAscendingIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.SortAscendingIcon.svg');
    dgPlace.Icons.SortDescendingIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.SortDescendingIcon.svg');
    dgPlace.Icons.CloseIcon.LoadFromFile('Place.WebPanel1.dgPlace.Icons.CloseIcon.svg');
    SetEvent(dgPlace, Self, 'OnCellClick', 'dgPlaceCellClick');
    dgPlace.RowCount := 1;
    dgdbaPlace.SetParentComponent(dgPlace);
    dgdbaPlace.Name := 'dgdbaPlace';
    dgdbaPlace.Left := 280;
    dgdbaPlace.Top := 56;
    dgdbaPlace.Width := 26;
    dgdbaPlace.Height := 26;
    dgdbaPlace.Visible := True;
    dgdbaPlace.Columns.Clear;
    with dgdbaPlace.Columns.Add do
    begin
      FieldName := 'LoadingNo';
      Header := 'LoadingNo';
      AutoCreated := False;
    end;
    with dgdbaPlace.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdbaPlace.Columns.Add do
    begin
      FieldName := 'CityNo';
      Header := 'CityNo';
      AutoCreated := False;
    end;
    dgdbaPlace.DataSource := dsPlaces;
    wcPlaces.SetParentComponent(Self);
    wcPlaces.Name := 'wcPlaces';
    wcPlaces.Connection := dmData.dbConnect;
    wcPlaces.Left := 88;
    wcPlaces.Top := 169;
    wdsPlaces.SetParentComponent(Self);
    wdsPlaces.Name := 'wdsPlaces';
    wdsPlaces.Connection := dmData.dbConnect;
    wdsPlaces.Left := 152;
    wdsPlaces.Top := 169;
    wdsPlacesLoadingNo.SetParentComponent(wdsPlaces);
    wdsPlacesLoadingNo.Name := 'wdsPlacesLoadingNo';
    wdsPlacesLoadingNo.FieldName := 'LoadingNo';
    wdsPlacesName.SetParentComponent(wdsPlaces);
    wdsPlacesName.Name := 'wdsPlacesName';
    wdsPlacesName.FieldName := 'Name';
    wdsPlacesCityNo.SetParentComponent(wdsPlaces);
    wdsPlacesCityNo.Name := 'wdsPlacesCityNo';
    wdsPlacesCityNo.FieldName := 'CityNo';
    dsPlaces.SetParentComponent(Self);
    dsPlaces.Name := 'dsPlaces';
    dsPlaces.DataSet := wdsPlaces;
    dsPlaces.Left := 216;
    dsPlaces.Top := 169;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    TMSFNCBitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    edtPlacePC.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    dgPlace.AfterLoadDFMValues;
    dgdbaPlace.AfterLoadDFMValues;
    wcPlaces.AfterLoadDFMValues;
    wdsPlaces.AfterLoadDFMValues;
    wdsPlacesLoadingNo.AfterLoadDFMValues;
    wdsPlacesName.AfterLoadDFMValues;
    wdsPlacesCityNo.AfterLoadDFMValues;
    dsPlaces.AfterLoadDFMValues;
  end;
end;

end.